import {Component, OnInit, AfterViewChecked} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';

// Services.
import {DataService} from '../../services/data/data.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  public result: any;//Observable<any>;
  public pages: any[];
  public loading: boolean;
  private searchText = new Subject<any>();

  public searchString: string;

  constructor(
    protected data: DataService,
    private route: ActivatedRoute,
    private transloco:TranslocoService
  ) {
    this.loading = false;
    this.searchString = '';

  }
  // Push a search text into the observable stream.
  public search(text: string, page: number): void {
    page = page ? page : 0;
    this.searchText.next({text: text, page: page});
    this.loading = true;
  }

  ngOnInit(): void {
    this.searchText.pipe(
      // Wait 300ms after each keystroke before considering the text
      debounceTime(500),
      // Ignore new text if same as previous text.
      distinctUntilChanged(),
      // Switch to new search observable each time the text changes.
      switchMap(data => this.data.search(data.text, data.page)),
    )
      .subscribe(
        (response) => {
          this.result = response;
          this.loading = false;
          this.pager();
        },
        error => this.processError(error)

      );


    // Get url parameter for a predefinied search.
    if (typeof this.route !== 'undefined'
      && typeof this.route.params !== 'undefined') {
      this.route.params.subscribe(params => {
        this.searchString = params['text'] ? params['text'] : '';
        this.search(this.searchString, 0);
      });
    }
  }

  /**
   * Handles pagination.
   */
  public pager() {
    let total = Math.ceil(this.result.totalResults / this.result.resultsPerPage);
    total = total ? total : 0;
    this.pages = new Array(total);
  }


  protected processError(error: any) {
    console.log('Error in SearchComponent: ', error)
  }
}



